import { HumanProcessingStatus } from "@dune/types";
import { Chip } from "@dune/ui";
import {
	humanProcessingStatusChipColorClassMap,
	humanProcessingStatusLabels,
} from "@dune/vars";

type FileStatusChipProps = {
	humanProcessingStatus: HumanProcessingStatus;
};

export const FileStatusChip = ({
	humanProcessingStatus,
}: FileStatusChipProps) => {
	return (
		<Chip
			label={humanProcessingStatusLabels[humanProcessingStatus]}
			color={humanProcessingStatusChipColorClassMap[humanProcessingStatus]}
		/>
	);
};
